import baseEditForm from 'formiojs/components/number/Number.form';

import ForceRequiredField from '../../../configuration-components/force-required/force-required';
import OriginalLabel from '../../../configuration-components/base-widget-configuration/display/original-label';
import BaseEditConditionalComponents from '../../../configuration-components/base-widget-configuration/base.edit.conditional.components';
import { BaseEditData } from '../../../configuration-components/base-widget-configuration/data/base.edit.data';
import LenderOnly from '../../../configuration-components/base-widget-configuration/display/lender-only-field-checkbox';
// eslint-disable-next-line max-lines-per-function
export default function (...extend: any[]) {
	return baseEditForm(
		[
			{
				key: 'api',
				ignore: true
			},
			{
				key: 'display',
				components: [OriginalLabel, { key: 'suffix', ignore: true }, LenderOnly]
			},
			new BaseEditData().getTab({
				components: {
					defaultComponents: [
						{
							key: 'decimalLimit',
							ignore: true
						},
						{
							key: 'inputFormat',
							ignore: true
						}
					]
				}
			}),
			{
				key: 'validation',
				components: ForceRequiredField
			},
			{
				key: 'conditional',
				components: BaseEditConditionalComponents
			},
			{
				key: 'logic',
				ignore: true
			},
			{
				key: 'layout',
				ignore: true
			}
		],
		...extend
	);
}
